export * from './IconHumidity';
export { default as IconHumidity } from './IconHumidity';
